// extracted by mini-css-extract-plugin
export default {"container":"container--mp-YrNAs","illustration":"illustration--mp-ioRQh","title":"title--mp-q5inm"};